import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import { TenantCommunityGuard } from '@src/components/guard/CommunityGuard';
import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CommunityMemberInvitationForm from '@src/features/shared/community/CommunityMemberInvitationForm';
import CommunityDefaultLayout from '@src/layouts/shared/CommunityDefaultLayout';

function CommunityMembersInvitation() {
  const tenantAuth = useTenantAuth();
  const isAdmin = !!tenantAuth.profile?.user?.isAdmin;
  return (
    <TenantCommunityGuard
      canRoles={[TENANT_ROLE.ADMIN]}
      canService={[SERVICE.ONLINE_COMMUNITY]}
      checkAuthenticate={true}
      checkPublicChannel={true}
      checkAccessibleNotPublicChannel={!isAdmin}
      checkStatus={isAdmin}
    >
      <CommunityDefaultLayout>
        <CommonHelmet />
        <CommunityMemberInvitationForm />
      </CommunityDefaultLayout>
    </TenantCommunityGuard>
  );
}

export default CommunityMembersInvitation;
